import React from 'react';
import './ExportProgressOverlay.css';

const ExportProgressOverlay = ({
  progress = 0,
  status = 'running',
  message = 'Exportando archivo',
  error = '',
  onClose,
}) => {
  const safeProgress = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  const isError = status === 'error';
  const isSuccess = status === 'success';
  const resolvedMessage = isError
    ? (error || 'No se pudo completar la exportación.')
    : isSuccess
      ? 'Exportación completada'
      : message;

  return (
    <div className={`export-progress-overlay export-progress-overlay--${status}`} role={isError ? 'alert' : 'status'}>
      <div className="export-progress-content">
        <span className={`export-progress-spinner${isError || isSuccess ? ' is-static' : ''}`} aria-hidden="true" />
        <div className="export-progress-copy">
          <p>{resolvedMessage}</p>
          <span>{safeProgress}%</span>
        </div>
        {isError && typeof onClose === 'function' ? (
          <button type="button" className="export-progress-close" onClick={onClose}>
            Cerrar
          </button>
        ) : null}
      </div>
      <div className={`export-progress-bar ${isError ? 'is-error' : 'is-ok'}`}>
        <div
          className={`export-progress-bar-fill ${isError ? 'is-error' : 'is-ok'}`}
          style={{ width: `${safeProgress}%` }}
        />
      </div>
    </div>
  );
};

export default ExportProgressOverlay;
